import { render, staticRenderFns } from "./videoSurveillance.vue?vue&type=template&id=6debd8a8&scoped=true&"
import script from "./videoSurveillance.vue?vue&type=script&lang=js&"
export * from "./videoSurveillance.vue?vue&type=script&lang=js&"
import style0 from "./videoSurveillance.vue?vue&type=style&index=0&id=6debd8a8&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6debd8a8",
  null
  
)

export default component.exports